
<app-cinta-superior></app-cinta-superior>
<div class="container spaceContainer">
  <div class="divDerecha">
    <button arial-label="enforcar contenido principal" mat-button (click)="irContenido()">Ir a contenido principal</button>
    <a tabindex="0" class="styleDate" style="text-decoration: none;">{{fecha | date: 'fullDate'}}</a>
    <button tabindex="0"  class="buttonOrange" (click)="ingresar()" type="button" id="idSalida" matTooltip="Ingresar a MVO" aria-label="Ingresar a modelo de orientacion vocacional">Ingresar</button>
  </div>
</div>
<app-navbar></app-navbar>
<!--Menú-->
<div>
  <div class="container spaceContainer">
    <nav class="navbar navbar-expand-lg navbar-light styleMenu" title="Menú del aplicativo">
      <button tabindex="0" class="navbar-toggler spaceToggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="banner">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse styleMenu" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item" *ngIf="pBooVerQueEsMVO">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" (click)="irQueEsMVO()">Que es Orientación Vocacional</a>
          </li>
          <li class="nav-item">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" (click)="irNoticia()">Noticias</a>
          </li>
          <li class="nav-item">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" (click)="DescargarManual()" matTooltip="Descargar Manual">Descargar Manual</a>
          </li>
          <li class="nav-item">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" target="_blank" href="http://oferta.senasofiaplus.edu.co/sofia-oferta/buscar-oferta-educativa.html" matTooltip="Estudia en el Sena">Estudia en el Sena</a>
          </li>
          <li class="nav-item">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" target="_blank" href="https://www.fondoemprender.com/" matTooltip="Fondo Emprender">Fondo Emprender</a>
          </li>
          <li class="nav-item">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" target="_blank" href="https://agenciapublicadeempleo.sena.edu.co/Paginas/inicio.aspx" matTooltip="Agencia Pública de Empleo">Agencia Pública de Empleo</a>
          </li>
          <li class="nav-item">
            <a tabindex="0" class="nav-link menuSpace underline" style="cursor: pointer;" target="_blank" href="https://observatorio.sena.edu.co/" matTooltip="Observatorio Sena">Observatorio Sena</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>

  <div class="backgroundBorder">
    <div class="container styleColorContainer">
      <!--Inicio banner-->
      <div>
        <div class="row justify-content-center" id="idContenido" tabindex="0">
          <div [ngStyle]="{'width':'100%'}">
            <div tabindex="-1" id="carouselExampleControls" class="carousel slide carruselSena">
              <div tabindex="-1" class="carousel-inner">
                <ngb-carousel tabindex="-1" #carousel id="carousel">

                  <ng-template ngbSlide *ngFor="let seccion of listaSeccionBanner">
                    <div [ngStyle]="{'width':'100%'}" class="picsum-img-wrapper" matTooltip="{{seccion.descripcionTooltip}}">
                      <a href="{{seccion.urlAsociada}}" class="enlaceCarrusel" target="{{seccion.targetBlank}}">
                        <img *ngIf="!bannerService.grises" class="d-block w-100 seccionB" src="{{seccion.imgColor}}"
                             alt="{{seccion.descripcionLector}}">
                        <img *ngIf="bannerService.grises" class="d-block w-100 seccionB" src="{{seccion.imgBlancoYNegro}}"
                             alt="{{seccion.descripcionLector}}">
                        <style>
                          .seccionB {
                            max-height: 358px;
                            object-fit: contain;
                            background-image: url("../../../assets/img/home/banner/bannerTransparente.png");
                            background-repeat: no-repeat;
                            background-size: 100% !important;
                          }
                        </style>
                      </a>
                    </div>
                  </ng-template>

                </ngb-carousel>
              </div>
              <a class="carousel-control-prev enlaceCarrusel" href="#carouselExampleControls" role="button" aria-label="" data-slide="prev">
                <span tabindex="0" class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Anterior</span>
              </a>
              <a class="carousel-control-next enlaceCarrusel" href="#carouselExampleControls" role="button" data-slide="next">
                <span tabindex="0" class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Siguiente</span>
              </a>
            </div>
            <br>
            <div class="button-position">
              <button class="btn btnRepoItemsOrange" name="btncontinuar" (click)="adminsitrarBanner()" type="submit" matTooltip="Carrusel de imágenes">{{btnNombreboton}}</button>
            </div>
            <div tabindex="0" class="textBanner">
              <p>Para presentar una prueba de orientación vocacional debes estar registrado en Sofia Plus y debes ingresar por esa opción con tus credenciales asignadas.</p>
            </div>
          </div>
        </div>
      </div>
      <!--Fin banner-->
      <!--Noticias-->
      <div class="text-center">
        <!-- Inico: que es MVO-->
        <div *ngIf="pBooVerQueEsMVO">
          <h1 tabindex="0" class="QueEsMVOIr"><b>Que es Orientación Vocacional</b></h1>
          <hr class="orangeHr">
          <div class="row">
            <p>

            </p>
          </div>
        </div>
        <!-- Fin: que es MVO-->
        <br />
        <!-- Inico: Noticias-->
        <h1 tabindex="0" class="noticiasIr"><b>Noticias</b></h1>
        <div class="row">
          <div class="col-md-4" tabindex="0" aria-label="Noticias de interés">
            <hr class="orangeHr">
            <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja" matTooltip="Noticia uno">
              <div class="tamañoImg">
                <div class="row">
                  <div class="col-md-12">
                    <img class="" src="../../../assets/img/home/Articulo1.jpg" id="noti1" alt="imagen noticia uno" class="imgNoticia">
                  </div>
                </div>
              </div>
              <div class="row pt-4 pr-3 pl-3">
                <div class="col-md-12">
                  <div class="tamañoTitulo">
                    <h2 tabindex="0"><b>Convenio entre el SENA y el Instituto Geográfico Agustín Codazzi fortalecerá la formación en áreas relacionadas con el catastro multipropósito</b></h2>
                  </div>
                  <div class="tamañoTexto">
                    <p tabindex="0" class="card-text">El acuerdo tiene una duración de tres años y espera beneficiar a aprendices, egresados y a la comunidad SENA en general.</p>
                  </div>
                  <a href="https://www.sena.edu.co/es-co/Noticias/Paginas/noticia.aspx?IdNoticia=5534" class="mt-2">Ver más noticias</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Inico: Servicios-->
          <div class="col-md-4" tabindex="0">
            <hr class="orangeHr">
            <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja" matTooltip="Noticia dos">
              <div class="tamañoImg">
                <div class="row">
                  <div class="col-md-12">
                    <img class="" src="../../../assets/img/home/Articulo2.jpg" id="noti2" alt="imagen noticia dos" class="imgNoticia">
                  </div>
                </div>
              </div>
              <div class="row pt-4 pr-3 pl-3">
                <div class="col-md-12">
                  <div class="tamañoTitulo">
                    <h2 tabindex="0"><b>Los 10 cafés especiales que representarán a Caldas en Boston fueron seleccionados en el SENA</b></h2>
                  </div>
                  <div class="tamañoTexto">
                    <p tabindex="0" class="card-text">Specialty Coffee Expo será la feria en donde participarán los cafés especiales caldenses que fueron seleccionados en la Escuela Nacional de la Calidad del Café y Paisaje Cultural Cafetero de Colombia del SENA Caldas en Chinchiná.</p>
                  </div>
                  <br />
                  <p>
                    <a href="https://www.sena.edu.co/es-co/Noticias/Paginas/noticia.aspx?IdNoticia=5535" class="mt-2">Ver más noticias</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" tabindex="0">
            <hr class="orangeHr">
            <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja" matTooltip="Noticia tres">
              <div class="tamañoImg">
                <div class="row">
                  <div class="col-md-12">
                    <img class="" src="../../../assets/img/home/Articulo3.jpg" id="noti3" alt="imagen noticia tres" class="imgNoticia">
                  </div>
                </div>
              </div>
              <div class="row pt-4 pr-3 pl-3">
                <div class="col-md-12">
                  <div class="tamañoTitulo">
                    <h2 tabindex="0"><b>SENA Girardot cuenta con el 1er laboratorio de fabricación aditiva en Cundinamarca</b></h2>
                  </div>
                  <div class="tamañoTexto">
                    <p tabindex="0" class="card-text">Con una inversión alrededor de $448 millones de pesos para la adecuación del laboratorio, compra de equipos y materiales de formación, se llevó a cabo un importante plan de modernización que busca acercar a diferentes grupos de interés a la industria 4.0</p>
                  </div>
                  <br />
                  <p>
                    <a href="https://www.sena.edu.co/es-co/Noticias/Paginas/noticia.aspx?IdNoticia=5539" class="mt-2">Ver más noticias</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4" tabindex="0" aria-label="Noticias de interés">
            <hr class="orangeHr">
            <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja" matTooltip="Noticia Cuadro">
              <div class="tamañoImg">
                <div class="row">
                  <div class="col-md-12">
                    <img class="" src="../../../assets/img/home/Articulo4.jpg" id="noti4" alt="imagen noticia uno" class="imgNoticia">
                  </div>
                </div>
              </div>
              <div class="row pt-4 pr-3 pl-3">
                <div class="col-md-12">
                  <div class="tamañoTitulo">
                    <h2 tabindex="0"><b>El SENA y la Alcaldía de Duitama anuncian convocatoria por $1.500 millones para los emprendedores del municipio</b></h2>
                  </div>
                  <div class="tamañoTexto">
                    <p tabindex="0" class="card-text">Con estos recursos se busca financiar la creación de 18 nuevas iniciativas empresariales a través del Fondo Emprender para reactivar la economía de esta región.</p>
                  </div>
                  <a href="https://www.sena.edu.co/es-co/Noticias/Paginas/noticia.aspx?IdNoticia=5530" class="mt-2">Ver más noticias</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" tabindex="0">
            <hr class="orangeHr">
            <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja" matTooltip="Noticia Cinco">
              <div class="tamañoImg">
                <div class="row">
                  <div class="col-md-12">
                    <img class="" src="../../../assets/img/home/Articulo5.jpg" id="noti5" alt="imagen noticia dos" class="imgNoticia">
                  </div>
                </div>
              </div>
              <div class="row pt-4 pr-3 pl-3">
                <div class="col-md-12">
                  <div class="tamañoTitulo">
                    <h2 tabindex="0"><b>SENNOVA desarrolla prototipo de protector solar antienvejecimiento en el SENA Chocó</b></h2>
                  </div>
                  <div class="tamañoTexto">
                    <p tabindex="0" class="card-text">Con extractos de plantas y semillas de la región, el equipo de SENNOVA del SENA en el Chocó, desarrolla prototipo de cremas de piel con protector solar antienvejecimiento y componentes de rejuvenecimiento.</p>
                  </div>
                  <a href="https://www.sena.edu.co/es-co/Noticias/Paginas/noticia.aspx?IdNoticia=5529" class="mt-2">Ver más noticias</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" tabindex="0">
            <hr class="orangeHr">
            <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja" matTooltip="Noticia Seis">
              <div class="tamañoImg">
                <div class="row">
                  <div class="col-md-12">
                    <img class="" src="../../../assets/img/home/Articulo6.jpg" id="noti6" alt="imagen noticia tres" class="imgNoticia">
                  </div>
                </div>
              </div>
              <div class="row pt-4 pr-3 pl-3">
                <div class="col-md-12">
                  <div class="tamañoTitulo">
                    <h2 tabindex="0"><b>Francisco José Gualteros inició su camino a Shanghái 2022</b></h2>
                  </div>
                  <div class="tamañoTexto">
                    <p tabindex="0" class="card-text">Se trata de un aprendiz del SENA Risaralda quien ganó medalla de oro en WorldSkills Colombia el año pasado, y se prepara para la competencia mundial en septiembre del presente año.</p>
                  </div>
                  <a href="https://www.sena.edu.co/es-co/Noticias/Paginas/noticia.aspx?IdNoticia=5550" class="mt-2">Ver más noticias</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin: Noticias-->
        <br />
        <!-- Inico: Servicios-->
        <h1 tabindex="0"><b>Servicios</b></h1>
        <div class="card-deck">
          <div class="card shadow-none border-0 p-0" tabindex="0" aria-label="">
            <hr class="orangeHr">
            <div class="card-body p-0">
              <a tabindex="0" href="https://asistencia.webv2.allus.com.co/WebAPI802/ChatSena/AdvancedChat/formchat.jsp" target="_blank" matTooltip="Recibe atención en línea por Chat">
                <img src="../../../assets/img/home/servicios/Chat_Boton.png" id="ServChat" alt="Recibe atención en línea por Chat" class="card-img">
              </a>
            </div>
          </div>
          <div class="card shadow-none border-0 p-0" tabindex="0" aria-label="">
            <hr class="orangeHr">
            <div class="card-body p-0 mt-2">
              <a tabindex="0" href="https://asistencia.webv2.allus.com.co/WebAPI802/VideoCallSenas/VideoCall/form.jsp" target="_blank" title="Asesoría en línea en lenguaje de señas">
                <img src="../../../assets/img/home/servicios/LenguajeSenas.gif" id="ServLeng" alt="Reciba asesoría en línea por lenguaje de señas" class="card-img">
              </a>
            </div>
          </div>
          <div class="card shadow-none border-0 p-0" tabindex="0" aria-label="">
            <hr class="orangeHr">
            <div class="card-body p-0">
              <a tabindex="0" href="https://api.whatsapp.com/send/?phone=573168760255&text&app_absent=0" target="_blank" matTooltip="WhatsApp SENA">
                <img src="../../../assets/img/home/servicios/Whatsapp_Boton.png" id="ServWhat" alt="WhatsApp SENA" class="card-img">
              </a>
            </div>
          </div>
        </div>
        <!-- FIN: Servicios-->
        <br />
        <br>

        <!--Sector Trabajo-->
        <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja">
          <div class="pl-3 pr-3 imgCenter">
            <h1 tabindex="0" aria-label="Sector Trabajo" class=" text-center titulo-sector-trabajo"><b>Sector Trabajo</b></h1>
            <hr class="orangeHr">
            <div class="row justify-content-center">
              <div class="col-md-2 box-image">
                <a tabindex="0" matTooltip="Ir a ministerio del trabajo" aria-label="Logo ministerio del trabajo"
                   (click)="mostrarAlerta('Ministerio del Trabajo','https://www.mintrabajo.gov.co','_blank')" class="cursor-pointer">
                  <img class="trabajoMinc" src="../../../assets/img/footer/Logo-MintrabajoTransparente_footer.png" alt="Logo ministerio del trabajo">
                </a>
              </div>
              <div class="col-md-2">
                <a tabindex="0" (click)="mostrarAlerta('Organizaciones solidarias','https://www.orgsolidarias.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Organizaciones solidarias" aria-label="Ir a Organizaciones solidarias">
                  <img class="org" src="../../../assets/img/footer/Logo-MintrabajoTransparente_footer.png" alt="Ir a Organizaciones solidarias">
                </a>
              </div>
              <div class="col-md-2">
                <a tabindex="0" (click)="mostrarAlerta('Servicio de empleo','https://www.serviciodeempleo.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a  Servicio de empleo" aria-label="Ir a  Servicio de empleo">
                  <img class="iempleo" src="../../../assets/img/footer/Logo-MintrabajoTransparente_footer.png" alt="Ir a  Servicio de empleo">
                </a>
              </div>
              <div class="col-md-2 imgCenter">
                <a tabindex="0" (click)="mostrarAlerta('Super Subsidio','https://www.ssf.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a  Super Subsidio" aria-label="Ir a  Super Subsidio">
                  <img class="superSub" src="../../../assets/img/footer/Logo-MintrabajoTransparente_footer.png" alt="Ir a  Super Subsidio">
                </a>
              </div>
              <div class="col-md-2">
                <a tabindex="0" (click)="mostrarAlerta('Colpensiones','http://www.colpensiones.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a  Colpensiones" aria-label="Ir a  Colpensiones">
                  <img class="colPen" src="../../../assets/img/footer/Logo-MintrabajoTransparente_footer.png" alt="Ir a  Colpensiones">
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-1 pb-5 shadow  mb-5 bg-gray rounded caja">
          <div class="pl-3 pr-3 mt-4">
            <div class="row">
              <div class="col-md-4">
                <a tabindex="0" matTooltip="Ir a página del gobierno" aria-label="Ir a página del gobierno"
                   (click)="mostrarAlerta('Gov Co','https://petro.presidencia.gov.co/','_blank')" class="cursor-pointer">
                  <div class="mincTrabajoU" alt="Logo del gobierno">
                  </div>
                </a>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-3">
                    <ul class="Min">
                      <li class="pinRed">
                        <a tabindex="0" (click)="mostrarAlerta('Presidencia','https://petro.presidencia.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Presidencia de la República de Colombia" aria-label="Ir a Presidencia de la República de Colombia">
                          Presidencia
                        </a>
                      </li>
                      <br>
                      <li class="pinGrean">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Interior','http://www.mininterior.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio del Interior" aria-label="Ir a Ministerio del Interior">
                          MinInterior
                        </a>
                      </li>
                      <br>
                      <li class="pinMinComercio">
                        <a tabindex="0" (click)="mostrarAlerta('Mnisterio de Comercio','https://www.mincit.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Comercio Industria y Turismo" aria-label="Ir a Ministerio de Comercio Industria y Turismo">
                          MinComercio
                        </a>
                      </li>
                      <br>
                      <li class="pinMinambiente">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Aambiente','http://www.minambiente.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Ambiente y Desarrollo Sostenible" aria-label="Ir a Ministerio de Ambiente y Desarrollo Sostenible">
                          MinAmbiente
                        </a>
                      </li>
                      <br>
                      <li class="pinMinSalud">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Salud','https://www.minsalud.gov.co/portada-covid-19.html','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Salud y Protección Social de Colombia" aria-label="Ir a Ministerio de Salud y Protección Social de Colombia">
                          MinSalud
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <ul class="Min">
                      <li class="pinVicepresidencia">
                        <a tabindex="0" (click)="mostrarAlerta('Vicepresidencia','https://fmm.vicepresidencia.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Vicepresidencia De La República" aria-label="Ir a Vicepresidencia De La República">
                          Vicepresidencia
                        </a>
                      </li>
                      <br>
                      <li class="pinMinrelaciones">
                        <a (click)="mostrarAlerta('Ministerio de Relaciones','http://www.cancilleria.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Relaciones exteriores" aria-label="Ir a Ministerio de Relaciones exteriores">
                          MinRelaciones
                        </a>
                      </li>
                      <br>
                      <li class="pinMineducacion">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Educación','https://www.mineducacion.gov.co/portal/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Educación Nacional" aria-label="Ir a Ministerio de Educación Nacional">
                          MinEducación
                        </a>
                      </li>
                      <br>
                      <li class="pinMintransporte">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Transporte','https://www.mintransporte.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de  Transporte" aria-label="Ir a Ministerio de  Transporte">
                          MinTransporte
                        </a>
                      </li>
                      <br>
                      <li class="pinVicepresidencia">
                        <a tabindex="0" (click)="mostrarAlerta('Urna de cristal','https://www.urnadecristal.gov.co/','_blank')" class="cursor-pointer" matTooltip=" Ir a Urna de cristal" aria-label="Ir a Urna de cristal">
                          Urna de cristal
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <ul class="Min">
                      <li class="pinMinjusticia">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Justicia','http://www.minjusticia.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio Justicia y del derecho" aria-label="Ir a Ministerio Justicia y del derecho">
                          MinJusticia
                        </a>
                      </li>
                      <br>
                      <li class="pinMinhacienda">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Hacienda','https://www.minhacienda.gov.co/webcenter/portal/Minhacienda','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Hacienda y Crédito Público" aria-label="Ir a Ministerio de Hacienda y Crédito Público">
                          MinHacienda
                        </a>
                      </li>
                      <br>
                      <li class="pinMincultura">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Cultura','https://mincultura.gov.co/Paginas/default.aspx','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Cultura " aria-label="Ir a Ministerio de Cultura">
                          MinCultura
                        </a>
                      </li>
                      <br>
                      <li class="pinMinvivienda">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Vivienda','https://www.minvivienda.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de  Vivienda Vivienda, Ciudad y Territorio" aria-label="Ir a Ministerio de  Vivienda Vivienda, Ciudad y Territorio">
                          MinVivienda
                        </a>
                      </li>
                      <br>
                      <li class="pinMintic">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Tecnologías de la Información y las Comunicaciones','https://www.mintic.gov.co/portal/inicio/','_blank')" class="cursor-pointer" matTooltip=" Ir a Ministerio de Tecnologías de la Información y las Comunicaciones de Colombia" aria-label="Ir a Ministerio de Tecnologías de la Información y las Comunicaciones de Colombia">
                          MinTic
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <ul class="Min">
                      <li class="pinMindefensa">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Defensa','https://www.mindefensa.gov.co/irj/portal/Mindefensa','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Defensa" aria-label="Ir a Ministerio de Defensa">
                          MinDefensa
                        </a>
                      </li>
                      <br>
                      <li class="pinMinminas">
                        <a (click)="mostrarAlerta('Ministerio de Minas','https://www.minenergia.gov.co','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Minas y Energía" aria-label="Ir a Ministerio de Minas y Energía">
                          MinMinas
                        </a>
                      </li>
                      <br>
                      <li class="pinMinagricultura">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio de Agricultura','https://www.minagricultura.gov.co/paginas/default.aspx','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio de Agricultura y Desarrollo Rural " aria-label="Ir a Ministerio de Agricultura y Desarrollo Rural">
                          MinAgricultura
                        </a>
                      </li>
                      <br>
                      <li class="pinMintrabajo">
                        <a tabindex="0" (click)="mostrarAlerta('Ministerio del Trabajo','https://www.mintrabajo.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio del Trabajo" aria-label="Ir a Ministerio del Trabajo">
                          MinTrabajo
                        </a>
                      </li>
                      <br>
                      <li class="pinMintrabajo">
                        <a (click)="mostrarAlerta('Ministerio del Deporte','https://www.mindeporte.gov.co/','_blank')" class="cursor-pointer" matTooltip="Ir a Ministerio  del deporte" aria-label="Ir a Ministerio  del deporte">
                          MinDeporte
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <app-cinta-inferior></app-cinta-inferior>
